export const rootFolder = {
  id: 'root',
  name: 'documents.modal.move_item.root_folder_name', // translate key
}
